import { render, staticRenderFns } from "./AssemblyCalc.vue?vue&type=template&id=3d53ef2d&scoped=true&"
import script from "./AssemblyCalc.vue?vue&type=script&lang=js&"
export * from "./AssemblyCalc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d53ef2d",
  null
  
)

export default component.exports